import React, { useEffect } from "react";
import TutorialList from "./TutorialList";
import { useIsMobile } from "../../../../hooks/useIsMobile";
import VideoPlayer from "../video-player";
import { getVideoUrls } from "../videoUrls";

const VideoTutorial = () => {
    const isMobile = useIsMobile(900);

    const path = window.location.pathname.split("/");
    const type = path[path.length - 1];

    const [url, setUrl] = React.useState<string>("");
    const [thumbnail, setThumbnail] = React.useState<string>("");

    useEffect(() => {
        const videoUrls = getVideoUrls(type);
        if (videoUrls) {
            setUrl(videoUrls.url);
            setThumbnail(videoUrls.thumbnail);
        }
    }, [type]);

    return (
        <div className="h-[calc(100vh - 5rem)] bg-white rounded">
            <main className="container mx-auto px-4 py-8">
                <div
                    className={`grid gap-8 ${
                        isMobile ? "grid-cols-1" : "grid-cols-[2fr_1fr]"
                    }`}
                >
                    <div>
                        <VideoPlayer url={url} thumbnail={thumbnail} />
                    </div>
                    <div>
                        <TutorialList type={type} />
                    </div>
                </div>
            </main>
        </div>
    );
};

export default VideoTutorial;
